"use strict";

exports.__esModule = true;
exports.AdvancedStripeChartHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AdvancedStripeChartHeader = exports.AdvancedStripeChartHeader = function AdvancedStripeChartHeader(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
    "data-testid": "AdvancedStripeChartHeader",
    level: 4,
    ellipsize: true
  }, props.columnLabel && props.columnLabel.length > 1 ? props.columnLabel : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AdvancedStripeChartHeader.headingLabel",
    defaultMessage: "Chart"
  }));
};